module.exports = __webpack_public_path__ + "static/media/footer-instagram.00ab1b70.svg";